import { GetterTree, MutationTree, ActionTree, Module } from 'vuex'
import { RootState } from './RootState'
import { DateHelper } from '@/shared/helpers/DateHelper'


/**
 * Constantes pour les méthodes du store.
 */
export enum InvoicingStoreMethods {
  GET_DATE_ENABLE_INVOICING = 'GET_DATE_ENABLE_INVOICING',
  GET_DATE_DISABLE_VESTA = 'GET_DATE_DISABLE_VESTA',
  GET_IS_INVOICING_ENABLED = 'GET_IS_INVOICING_ENABLED',
  GET_IS_VESTA_DISABLED = 'GET_IS_VESTA_DISABLED',
  GET_DAYS_BEFORE_ENABLE = 'GET_DAYS_BEFORE_ENABLE',
  GET_DAYS_BEFORE_DISABLE_VESTA = 'GET_DAYS_BEFORE_DISABLE_VESTA',

  SET_DATES = 'SET_DATES',
  SET_DATE_ENABLE_INVOICING = 'SET_DATE_ENABLE_INVOICING',
  SET_DATE_DISABLE_VESTA = 'SET_DATE_DISABLE_VESTA'
}

/**
 * Modèle du state Invoicing.
 */
export class InvoicingState {
  public dateEnableInvoicing: Date | undefined = undefined
  public dateDisableVesta: Date | undefined = undefined
}

/**
 * Getters du store.
 */
const getters: GetterTree<InvoicingState, RootState> = {
  [InvoicingStoreMethods.GET_DATE_ENABLE_INVOICING]:
    (state) => state.dateEnableInvoicing,

  [InvoicingStoreMethods.GET_DATE_DISABLE_VESTA]:
    (state) => state.dateDisableVesta,

  [InvoicingStoreMethods.GET_IS_INVOICING_ENABLED]:
    (state) =>
      state.dateEnableInvoicing
        ? !DateHelper.isInFuture(state.dateEnableInvoicing)
        : false,

  [InvoicingStoreMethods.GET_IS_VESTA_DISABLED]:
    (state) =>
      state.dateDisableVesta
        ? !DateHelper.isInFuture(state.dateDisableVesta)
        : false,

  [InvoicingStoreMethods.GET_DAYS_BEFORE_ENABLE]:
    (state) =>
      DateHelper.daysBefore(state.dateEnableInvoicing),

  [InvoicingStoreMethods.GET_DAYS_BEFORE_DISABLE_VESTA]:
    (state) =>
      DateHelper.daysBefore(state.dateDisableVesta)
}


/**
 * Mutations du store.
 */
const mutations: MutationTree<InvoicingState> = {
  [InvoicingStoreMethods.SET_DATES]: (
    state: InvoicingState,
    payload: {
      dateEnableInvoicing?: string | Date | null
      dateDisableVesta?: string | Date | null
    }
  ) => {
    state.dateEnableInvoicing =
      DateHelper.parseISODate(payload.dateEnableInvoicing) ?? undefined

    state.dateDisableVesta =
      DateHelper.parseISODate(payload.dateDisableVesta) ?? undefined
  },

  [InvoicingStoreMethods.SET_DATE_ENABLE_INVOICING]: (
    state: InvoicingState,
    date?: string | Date | null
  ) => {
    state.dateEnableInvoicing =
      DateHelper.parseISODate(date) ?? undefined
  },

  [InvoicingStoreMethods.SET_DATE_DISABLE_VESTA]: (
    state: InvoicingState,
    date?: string | Date | null
  ) => {
    state.dateDisableVesta =
      DateHelper.parseISODate(date) ?? undefined
  }
}

/**
 * Actions du store.
 */
const actions: ActionTree<InvoicingState, RootState> = {
  initialiseDates({ commit }, payload) {
    commit(InvoicingStoreMethods.SET_DATES, payload)
  }
}

/**
 * Export du module
 */
export const InvoicingStore: Module<InvoicingState, RootState> = {
  state: new InvoicingState(),
  getters,
  mutations,
  actions,
  namespaced: false
}
